export default __webpack_public_path__ + "static/media/Urus.7513bc1f.png";